import { MessageCircle, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { CONTACT } from "../i18n";
import { FadeUp } from "./Reveal";

export const Contact = () => {
  const { t } = useLang();
  return (
    <section
      id="contact"
      className="relative py-28 md:py-44 bg-[#0a0a0a] overflow-hidden"
      data-testid="contact-section"
    >
      <div className="absolute inset-0 gold-glow" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col items-center text-center">
        <FadeUp>
          <p className="font-mono text-xs tracking-[0.3em] text-[#d4af37] mb-8">{t.contact.overline}</p>
        </FadeUp>
        <FadeUp delay={0.1}>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-7xl tracking-tight text-white max-w-4xl leading-[1.05]">
            {t.contact.title}
          </h2>
        </FadeUp>
        <FadeUp delay={0.2}>
          <p className="font-sans text-base md:text-lg text-white/60 max-w-xl mt-8 leading-relaxed">
            {t.contact.desc}
          </p>
        </FadeUp>

        <FadeUp delay={0.3}>
          <a
            href={`tel:${CONTACT.phoneTel}`}
            className="block font-serif text-4xl sm:text-6xl lg:text-7xl text-[#f7e7ce] mt-14 hover:text-[#d4af37] transition-colors duration-500 tracking-tight"
            data-testid="contact-phone-display"
          >
            {CONTACT.phoneDisplay}
          </a>
        </FadeUp>

        <FadeUp delay={0.4}>
          <div className="flex flex-wrap items-center justify-center gap-4 mt-14">
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-pill inline-flex items-center gap-3 rounded-full bg-[#25D366] px-8 py-4 font-sans font-medium text-black hover:scale-[1.03]"
              data-testid="contact-whatsapp-btn"
            >
              <MessageCircle size={20} />
              {t.contact.whatsapp}
            </a>
            <a
              href={`tel:${CONTACT.phoneTel}`}
              className="btn-pill inline-flex items-center gap-3 rounded-full border border-white/25 px-8 py-4 font-sans font-medium text-white hover:bg-white hover:text-black"
              data-testid="contact-call-btn"
            >
              <Phone size={20} />
              {t.contact.call}
            </a>
          </div>
        </FadeUp>
      </div>
    </section>
  );
};

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative bg-[#050505] border-t border-white/10 py-16" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-10">
          <div>
            <div className="flex items-baseline gap-2 mb-4">
              <span className="font-serif text-2xl tracking-tight text-white">VIP</span>
              <span className="font-sans text-sm tracking-[0.35em] uppercase text-[#d4af37]">
                Girne Taksi
              </span>
            </div>
            <p className="font-sans text-sm text-white/50 max-w-xs leading-relaxed">{t.footer.tagline}</p>
          </div>

          <div className="flex flex-col md:items-end gap-3">
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="font-sans text-sm text-white/70 hover:text-[#25D366] transition-colors"
              data-testid="footer-whatsapp"
            >
              WhatsApp · {CONTACT.phoneDisplay}
            </a>
            <a
              href={`tel:${CONTACT.phoneTel}`}
              className="font-sans text-sm text-white/70 hover:text-white transition-colors"
              data-testid="footer-phone"
            >
              {CONTACT.phoneDisplay}
            </a>
            <span className="font-sans text-sm text-white/40">vipgirnetaksi.com</span>
            <Link
              to="/ektiren"
              className="font-sans text-sm text-white/50 hover:text-[#d4af37] transition-colors mt-1"
              data-testid="footer-about-ektiren"
            >
              {t.footer.aboutEktiren}
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="font-mono text-xs text-white/40">
            © {new Date().getFullYear()} VIP Girne Taksi. {t.footer.rights}
          </span>
          <Link
            to="/ektiren"
            className="group inline-flex items-center gap-2 font-mono text-xs text-white/50 hover:text-[#d4af37] transition-colors"
            data-testid="ektiren-link"
          >
            {t.footer.by}
            <span className="text-[#d4af37] group-hover:translate-x-0.5 transition-transform">→</span>
          </Link>
        </div>
      </div>
    </footer>
  );
};
